export const VideoChatTrackNames = {
    USER_MIC: "user-mic",
    USER_WEBCAM: "user-webcam",
    USER_SCREEN: "user-screen",
};

export const LAST_VISITED_ROOMS_LIST_SIZE = 3;

export const MEMBERS_LIST_TO_FETCH_PAGE_SIZE = 10;
